module.exports = {
    assign: 1,
    unassign: 2
};